// extracted by mini-css-extract-plugin
export default {"questionsList":"ChallengeQuestionsList_questionsList__2kJOM"};